// importing compoents for new section of pmgc

import Index from './index'

export default [
  {
    path: '/news',
    name: 'Platinum Minds Global Company News',
    component: Index
  }
]



// WEBPACK FOOTER //
// ./src/pmgc/news/router.js